import Image from 'next/image';
import React from 'react';
import { USPcontainer, USPContent } from './styled';
import { images } from '../../../Constants/ImageUrls';

export default function CarouselContent(props) {
  const { element, isForNewCdPage, handleNext, handlePrev } = props;
  return (
    <div>
      <USPcontainer isForNewCdPage={isForNewCdPage}>
        <Image
          src={element?.mobileWebImage}
          alt={element?.heading}
          quality={80}
          fill
          sizes="80vw"
        />
        {isForNewCdPage && (
          <div className="carousel-arrows">
            <Image
              className="carousel-left-arrow"
              src={images.carousel_left_arrow}
              aria-label={'Prev Slide'}
              width={40}
              height={40}
              onClick={handlePrev}
              style={{
                maxWidth: '100%',
                height: 'auto',
              }}
            />
            <Image
              className="carousel-right-arrow"
              src={images.carousel_right_arrow}
              aria-label={'Next Slide'}
              width={40}
              height={40}
              onClick={handleNext}
              style={{
                maxWidth: '100%',
                height: 'auto',
              }}
            />
          </div>
        )}
      </USPcontainer>
      {element?.heading && element.subHeading && (
        <USPContent>
          <h3>{element?.heading}</h3>
          <p>{element?.subHeading}</p>
        </USPContent>
      )}
    </div>
  );
}
